var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "linkedin-v2_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.438 0H6.563A6.56 6.56 0 0 0 0 6.563v14.875A6.56 6.56 0 0 0 6.563 28h14.875A6.56 6.56 0 0 0 28 21.438V6.563A6.56 6.56 0 0 0 21.438 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M21.438 0H6.563A6.56 6.56 0 0 0 0 6.563v14.875A6.56 6.56 0 0 0 6.563 28h14.875A6.56 6.56 0 0 0 28 21.438V6.563A6.56 6.56 0 0 0 21.438 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.203 23.81h3.202a.437.437 0 0 0 .437-.438l.002-6.764c0-3.535-.762-6.253-4.893-6.253a4.3 4.3 0 0 0-3.851 2.103.035.035 0 0 1-.058.004.04.04 0 0 1-.007-.021v-1.322a.437.437 0 0 0-.438-.437H11.56a.44.44 0 0 0-.437.437v12.252a.44.44 0 0 0 .437.438h3.201a.437.437 0 0 0 .438-.438v-6.056c0-1.713.325-3.371 2.448-3.371 2.093 0 2.12 1.96 2.12 3.482v5.946a.44.44 0 0 0 .437.437M4.156 6.521a2.377 2.377 0 0 0 2.366 2.365 2.377 2.377 0 0 0 2.365-2.366 2.377 2.377 0 0 0-2.365-2.365 2.377 2.377 0 0 0-2.366 2.366m.761 17.287h3.206a.44.44 0 0 0 .437-.437V11.119a.437.437 0 0 0-.437-.437H4.917a.44.44 0 0 0-.437.437v12.253a.44.44 0 0 0 .437.437"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "linkedin-v2_svg__a"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export { SvgLinkedinV2 as ReactComponent };
export default __webpack_public_path__ + "49186215261e51ff6010ca97dd0b3e34.svg";